export default class BCMSStateManagerCRUD {
    _state; // Stores the state that the operations should be applied to
    _operations; // The operations that should be applied to the state
  
    // CONSTRUCTOR :: OBJECT -> this
    constructor(state) {
        this.state = state;
        this.operations = [];
    }
  
    // state :: OBJECT -> VOID
    // Setter for the state variable
    set state(value) { this._state = value; }
    
    // state :: VOID -> OBJECT
    // Getter for the state variable
    get state() { return this._state; }
    
    // operations :: ARRAY -> VOID
    // Setter for the operations variable
    set operations(value) { this._operations = value; }

    // operations :: VOID -> ARRAY
    // Getter for the operations variable
    get operations() { return this._operations; }

    // combine :: bcmsStateManagerCRUD -> this
    // Merges the operations of the passed bcmsStateManagerCRUD with the current instance
    combine(manager) {
        if(manager instanceof BCMSStateManagerCRUD) {
            this.operations = [ ...this.operations, ...manager.operations ];
            return this;
        }

        throw new Error("FAILED: Cannot combine a non BCMSStateManagerCRUD instance");
    }
  
    // update :: (ARRAY, *) -> this
    // Creates and operation to update the value within the state
    update(props, value) {
        this.operations.push(state => {
            let properties = props;
  
            (function setData(data) {
                const currentProp = properties[0];
                properties = properties.slice(1);
  
                if(properties.length > 0) { setData(data[currentProp]); }
                else { data[currentProp] = value; }
            })(state);
  
            return state;
        });
  
        return this;
    }
  
    // submit :: FUNCTION -> VOID|OBJECT
    // Goes through all the operations passing the set state, then if the fn parameter is a function
    // then calls the function passing the state. Otherwise just return the value
    submit(fn) {
        const state = this.operations.reduce((result, operation) => operation(result), this._state);
        this.operations = [];

        if(fn instanceof Function) { fn({ ...state }); }
        else{ return state; }
    }
  
    // init :: OBJECT -> bcmsStateManagerCRUD
    // Initalizes a new instance and returns
    static init(state) {
        return new BCMSStateManagerCRUD(state);
    }
  
    // batch :: ARRAY -> OBJECT
    // Goes through all operations passing the state then return the outcome
    static batch(instances) {
        const operations = instances.reduce((result, instance) => result.concat(instance.operations), []);
        return operations.reduce((result, operation) => operation(result), this._state);
    }
  }